import React from "react";

import Icon from "@/assets/images/icons";
import BrandModal from "@/common/Modal/BrandModal";
import Text from "@/common/Text/Text";
import { Button } from "antd";
import styles from "./ReleaseMakeActiveModal.module.scss";

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  currentVersion: string;
  nextVersion: string;
  appType?: "krosskast" | "assistant" | "player";
}

const ReleaseMakeActiveModal: React.FC<Props> = ({
  open,
  onCancel,
  onConfirm,
  currentVersion,
  nextVersion,
  appType = "assistant",
}) => {
  return (
    <BrandModal
      title="Are you sure you want to make this APK active?"
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <div className={styles.container}>
        <Text type="title" size="md" className={styles.subtitle}>
          Staging APK
        </Text>

        <div className={styles.versionContainer}>
          <div className={styles.versionRow}>
            <Text type="text" size="md" className={styles.versionText}>
              <span className={styles.versionLabel}>Currently active:</span>
              <span className={styles.versionValue}>
                <Icon
                  name={appType}
                  size={16}
                  useImage
                  className={styles.icon}
                />
                {currentVersion}
              </span>
            </Text>
          </div>

          <div className={styles.versionRow}>
            <Text type="text" size="md" className={styles.versionText}>
              <span className={styles.versionLabel}>Make active:</span>
              <span className={styles.versionValue}>
                <Icon
                  name={appType}
                  size={16}
                  useImage
                  className={styles.icon}
                />
                {nextVersion}
              </span>
            </Text>
          </div>
        </div>

        <Text size="sm" className={styles.description}>
          This will update the current active staging version and may affect
          existing configurations or user experiences.
        </Text>

        <Button type="primary" danger onClick={onConfirm}>
          Make Active
        </Button>
      </div>
    </BrandModal>
  );
};

export default ReleaseMakeActiveModal;
